import { defineComponent } from "vue";
import useRoomMoreHooks from "./useRoomMoreHooks.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import copyIcon from "../common/icons/CopyIcon.vue.mjs";
import EmailIcon from "../common/icons/EmailIcon.vue.mjs";
import TuiButton from "../common/base/Button.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexPC",
  setup(__props) {
    const { t, onCopy, handleClick, email, isZH } = useRoomMoreHooks();
    return { __sfc: true, t, onCopy, handleClick, email, isZH, SvgIcon, CopyIcon: copyIcon, EmailIcon, TuiButton };
  }
});
export {
  _sfc_main as default
};
